import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const token = localStorage.getItem("token");

export const AuthRouteMiddleware = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!token && !location.pathname.includes("/auth")) {
      navigate("/auth");
    }

    if (token && location.pathname.includes("/auth")) {
      navigate("/");
    }
  }, [location, navigate]);

  return <Outlet />;
};
